import { CollapsibleSection } from '@strata/react-collapsible-section';
import classNames from 'classnames';
import { type ReactNode } from 'react';

interface SectionProps {
    contentArray?: ReactNode[];
    title: ReactNode;
}

export const Section = ({ contentArray = [], title }: SectionProps) => (
    <div className={classNames('sds_section')}>
        <CollapsibleSection
            title={<h2>{title}</h2>}
            content={
                <div className="sds_section__container">
                    {contentArray.map((content, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div key={index}>{content}</div>
                    ))}
                </div>
            }
        />
    </div>
);
